import React, { useState, useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import SurveyStatisticsPopup from "./SurveyStatisticsPopup";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Spinner,
  Text,
  Alert,
  AlertIcon,
  useColorModeValue,
} from "@chakra-ui/react";

const SurveyTable = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSurveyId, setSelectedSurveyId] = useState(null);

  const headerBg = useColorModeValue("#222", "gray.700");
  const headerColor = useColorModeValue("#fff", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const hoverBg = useColorModeValue("gray.50", "gray.700");

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await axiosInstance.get("/surveys");
        setSurveys(response.data);
      } catch (err) {
        setError("خطأ في جلب الاستبيانات"); // Translated error message
      } finally {
        setLoading(false);
      }
    };
    fetchSurveys();
  }, []);

  const handleViewStatistics = (surveyId) => {
    setSelectedSurveyId(surveyId);
  };

  if (loading) {
    return (
      <Box textAlign="center" py={4} dir="rtl">
        <Spinner size="xl" />
        <Text mt={2}>جاري التحميل...</Text> {/* Translated */}
      </Box>
    );
  }

  if (error) {
    return (
      <Alert status="error" dir="rtl">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box
      mt={8}
      p={6}
      borderRadius="lg"
      borderWidth="1px"
      borderColor={borderColor}
      boxShadow="lg"
      bg="white"
      dir="rtl"
    >
      <Table variant="striped" colorScheme="blue">
        <Thead>
          <Tr>
            <Th bg={headerBg} color={headerColor} textAlign="right">العنوان</Th>
            <Th bg={headerBg} color={headerColor} textAlign="right">تاريخ الإنشاء</Th>
            <Th bg={headerBg} color={headerColor} textAlign="right">الإجراءات</Th>
          </Tr>
        </Thead>
        <Tbody>
          {surveys.map((survey) => (
            <Tr key={survey._id} _hover={{ bg: hoverBg }}>
              <Td textAlign="right">{survey.title}</Td>
              <Td textAlign="right">
                {new Date(survey.createdAt).toLocaleDateString("ar-EG")}
              </Td>
              <Td textAlign="right">
                <Button
                  colorScheme="blue"
                  size="sm"
                  onClick={() => handleViewStatistics(survey._id)}
                >
                  عرض الإحصائيات
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {selectedSurveyId && (
        <SurveyStatisticsPopup
          surveyId={selectedSurveyId}
          onClose={() => setSelectedSurveyId(null)}
        />
      )}
    </Box>
  );
};

export default SurveyTable;



